import {
    ComponentStoreV2Factory,
} from '../../../../../modules/shared/store/common/component-store-v2.factory';
import { computed, Injectable } from '@angular/core';
import { ServicePatternObject } from '@libs/types/src/services/object-type/service/service-pattern.object';
import { ServicePatternDocumentUsageEnum } from '@libs/types/src/services/enum/service-pattern-document-usage.enum';

@Injectable()
export class IndividualPlanPrintDialogStore extends ComponentStoreV2Factory {

    public headers = computed(() => {
        return this.data.getServicePatterns()?.['items']
                ?.filter((it: ServicePatternObject) => it.usage === ServicePatternDocumentUsageEnum.header)
            || [];
    });

    public footers = computed(() => {
        return this.data.getServicePatterns()?.['items']
                ?.filter((it: ServicePatternObject) => it.usage === ServicePatternDocumentUsageEnum.footer)
            || [];
    });

    public tags = computed(() => {
        const tags = this.data.getIndividualPlanFolderTags() || [];
        return tags.map((it) => ({
            value: it,
            name: it,
        }))
    })

}
